import React, { useContext } from 'react';
import { PageContext } from '@leuven2030/framework/Page/Page';
import 'twin.macro';
import ContentCover, {
  ContentCoverTitle
} from '@leuven2030/framework/Content/ContentCover';
import DateDot from '@leuven2030/food/Date/DateDot';
import { StyleContent } from '@leuven2030/framework/styles/general';
import NavigationLink from '@leuven2030/framework/Navigation/NavigationLink';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
const NewsArticleCover = () => {
  const {
    prismic: {
      news_article: { event_date_start, cover, group }
    }
  } = useContext(PageContext);

  return (
    <ContentCover
      image={cover}
      tw="py-0"
      resetContentStyle
      imgixParams={{
        blend: '8c222222',
        fit: 'crop',
        crop: 'entropy'
      }}
    >
      <div tw="absolute top-0 left-0 w-full h-full flex flex-col justify-end items-start">
        <div css={StyleContent}>
          <div tw="py-6 space-y-3">
            {group._meta.uid === 'event' && <DateDot date={event_date_start} />}
            <div tw="text-primary-300 text-lg flex items-center">
              <KeyboardArrowLeft />
              <NavigationLink prismicMeta={group}>
                <h3>{group.show_all_label}</h3>
              </NavigationLink>
            </div>
          </div>
        </div>
      </div>
    </ContentCover>
  );
};

export default NewsArticleCover;
